/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { loadSettings, saveSettings } from './utils/settingsManager';
import getBackendUrl from './utils/backendConfig';

const BACKEND_URL = getBackendUrl();

const SettingsPanel = ({ isOpen, onClose, onSettingsChange }) => {
  const [settings, setSettings] = useState(loadSettings());
  const [apiStatus, setApiStatus] = useState(null);
  const [showAdvanced, setShowAdvanced] = useState(false);

  // Charger le statut des API
  useEffect(() => {
    if (isOpen && showAdvanced) {
      fetchApiStatus();
    }
  }, [isOpen, showAdvanced]);

  const fetchApiStatus = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/health`);
      const data = await response.json();
      setApiStatus(data);
    } catch (error) {
      console.error('Error fetching API status:', error);
    }
  };

  const handleThemeToggle = () => {
    const newTheme = settings.theme === 'light' ? 'dark' : 'light';
    const newSettings = { ...settings, theme: newTheme };
    setSettings(newSettings);
    saveSettings(newSettings);
    onSettingsChange(newSettings);
  };

  const handleFontSizeChange = (size) => {
    const newSettings = { ...settings, fontSize: size };
    setSettings(newSettings);
    saveSettings(newSettings);
    onSettingsChange(newSettings);
  };

  const handleBibleVersionChange = (version) => {
    const newSettings = { ...settings, bibleVersion: version };
    setSettings(newSettings);
    saveSettings(newSettings);
    onSettingsChange(newSettings);
  };

  const handleNotificationsToggle = () => {
    const newSettings = { ...settings, notificationsEnabled: !settings.notificationsEnabled };
    setSettings(newSettings);
    saveSettings(newSettings);
    onSettingsChange(newSettings);
  };

  const handleClearHistory = () => {
    if (window.confirm('Êtes-vous sûr de vouloir effacer tout l\'historique ?')) {
      localStorage.removeItem('search-history');
      localStorage.removeItem('reading-history');
      alert('Historique effacé avec succès !');
    }
  };

  const handleExportNotes = () => {
    const notes = localStorage.getItem('bible-study-notes');
    if (!notes || notes === '""' || notes === 'null') {
      alert('Aucune note à exporter');
      return;
    }
    const blob = new Blob([JSON.parse(notes)], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `mes-notes-bibliques-${new Date().toISOString().split('T')[0]}.txt`;
    a.click();
    URL.revokeObjectURL(url);
    alert('Notes exportées avec succès !');
  };

  if (!isOpen) return null;

  // ===== INLINE STYLES =====

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.6)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
    padding: '20px'
  };

  const panelStyle = {
    background: 'white',
    borderRadius: '20px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    maxWidth: '700px',
    width: '100%',
    maxHeight: '90vh',
    overflowY: 'auto'
  };

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '25px 30px',
    borderBottom: '2px solid #f0f0f0',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    borderRadius: '20px 20px 0 0',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 10
  };

  const titleStyle = {
    margin: 0,
    fontSize: '24px',
    fontWeight: '700',
    fontFamily: "'Montserrat', sans-serif",
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  };

  const closeBtnStyle = {
    background: 'rgba(255, 255, 255, 0.2)',
    border: '2px solid rgba(255, 255, 255, 0.3)',
    color: 'white',
    fontSize: '24px',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
    fontWeight: 'bold'
  };

  const contentStyle = {
    padding: '30px'
  };

  const sectionStyle = {
    marginBottom: '30px',
    paddingBottom: '25px',
    borderBottom: '1px solid #f0f0f0'
  };

  const sectionTitleStyle = {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '15px',
    color: '#2c3e50',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontFamily: "'Montserrat', sans-serif"
  };

  const themeContainerStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '15px'
  };

  const getThemeButtonStyle = (isActive) => ({
    padding: '20px',
    border: isActive ? '3px solid #667eea' : '2px solid #e0e0e0',
    borderRadius: '12px',
    background: isActive ? 'linear-gradient(135deg, #667eea15 0%, #764ba215 100%)' : 'white',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    boxShadow: isActive ? '0 4px 15px rgba(102, 126, 234, 0.2)' : '0 2px 8px rgba(0, 0, 0, 0.05)',
    transform: isActive ? 'scale(1.02)' : 'scale(1)'
  });

  const themeIconStyle = {
    fontSize: '32px'
  };

  const themeLabelStyle = {
    fontSize: '14px',
    fontWeight: '600',
    color: '#2c3e50',
    fontFamily: "'Montserrat', sans-serif"
  };

  const fontSizeContainerStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '12px'
  };

  const getFontSizeButtonStyle = (isActive) => ({
    padding: '15px 10px',
    border: isActive ? '3px solid #667eea' : '2px solid #e0e0e0',
    borderRadius: '10px',
    background: isActive ? 'linear-gradient(135deg, #667eea15 0%, #764ba215 100%)' : 'white',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    boxShadow: isActive ? '0 4px 15px rgba(102, 126, 234, 0.2)' : '0 2px 8px rgba(0, 0, 0, 0.05)',
    transform: isActive ? 'scale(1.05)' : 'scale(1)'
  });

  const fontSizeIconStyle = (size) => ({
    fontSize: size === 'small' ? '16px' : size === 'medium' ? '20px' : size === 'large' ? '24px' : '28px',
    fontWeight: '700',
    color: '#2c3e50'
  });

  const fontSizeLabelStyle = {
    fontSize: '11px',
    fontWeight: '600',
    color: '#64748b',
    fontFamily: "'Montserrat', sans-serif"
  };

  const selectStyle = {
    width: '100%',
    padding: '12px 16px',
    fontSize: '14px',
    border: '2px solid #e0e0e0',
    borderRadius: '10px',
    background: 'white',
    cursor: 'pointer',
    fontFamily: "'Montserrat', sans-serif",
    transition: 'border-color 0.2s ease'
  };

  const actionButtonStyle = {
    padding: '12px 20px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontFamily: "'Montserrat', sans-serif",
    marginRight: '10px',
    marginTop: '10px'
  };

  const dangerButtonStyle = {
    ...actionButtonStyle,
    background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'
  };

  const toggleContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '15px',
    background: '#f8fafc',
    borderRadius: '10px',
    border: '2px solid #e2e8f0'
  };

  const toggleLabelStyle = {
    fontSize: '14px',
    fontWeight: '600',
    color: '#2c3e50',
    fontFamily: "'Montserrat', sans-serif"
  };

  const toggleSwitchStyle = (isOn) => ({
    width: '50px',
    height: '26px',
    background: isOn ? '#667eea' : '#cbd5e1',
    borderRadius: '13px',
    cursor: 'pointer',
    position: 'relative',
    transition: 'background 0.3s ease'
  });

  const toggleCircleStyle = (isOn) => ({
    width: '22px',
    height: '22px',
    background: 'white',
    borderRadius: '50%',
    position: 'absolute',
    top: '2px',
    left: isOn ? '26px' : '2px',
    transition: 'left 0.3s ease',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
  });

  const advancedToggleStyle = {
    padding: '12px 20px',
    background: '#f1f5f9',
    color: '#475569',
    border: '2px solid #e2e8f0',
    borderRadius: '10px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontFamily: "'Montserrat', sans-serif",
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  };

  const apiGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: '10px',
    marginTop: '15px'
  };

  const apiLedStyle = (isActive) => ({
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    background: isActive ? '#10b981' : '#ef4444',
    boxShadow: isActive ? '0 0 15px rgba(16, 185, 129, 0.5)' : '0 0 10px rgba(239, 68, 68, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '10px',
    fontWeight: 'bold',
    color: 'white'
  });

  const previewBoxStyle = {
    padding: '20px',
    background: '#f8fafc',
    borderRadius: '12px',
    border: '2px solid #e2e8f0',
    marginTop: '15px'
  };

  const previewTextStyle = {
    fontSize: settings.fontSize === 'small' ? '14px' : settings.fontSize === 'medium' ? '16px' : settings.fontSize === 'large' ? '18px' : '20px',
    lineHeight: '1.6',
    color: '#2c3e50',
    marginBottom: '10px',
    fontFamily: "'Georgia', serif"
  };

  const previewCaptionStyle = {
    fontSize: '12px',
    fontStyle: 'italic',
    color: '#64748b',
    fontFamily: "'Montserrat', sans-serif"
  };

  const saveBtnStyle = {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginTop: '20px',
    boxShadow: '0 6px 20px rgba(102, 126, 234, 0.25)',
    fontFamily: "'Montserrat', sans-serif",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  };

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={panelStyle} onClick={(e) => e.stopPropagation()}>
        <div style={headerStyle}>
          <h2 style={titleStyle}>⚙️ Paramètres</h2>
          <button style={closeBtnStyle} onClick={onClose}>✕</button>
        </div>

        <div style={contentStyle}>
          {/* Thème */}
          <div style={sectionStyle}>
            <h3 style={sectionTitleStyle}>🌙 Thème</h3>
            <div style={themeContainerStyle}>
              <button
                style={getThemeButtonStyle(settings.theme === 'light')}
                onClick={handleThemeToggle}
              >
                <span style={themeIconStyle}>☀️</span>
                <span style={themeLabelStyle}>Mode Clair</span>
              </button>
              <button
                style={getThemeButtonStyle(settings.theme === 'dark')}
                onClick={handleThemeToggle}
              >
                <span style={themeIconStyle}>🌙</span>
                <span style={themeLabelStyle}>Mode Sombre</span>
              </button>
            </div>
          </div>

          {/* Taille de Police */}
          <div style={sectionStyle}>
            <h3 style={sectionTitleStyle}>📝 Taille de Police</h3>
            <div style={fontSizeContainerStyle}>
              <button
                style={getFontSizeButtonStyle(settings.fontSize === 'small')}
                onClick={() => handleFontSizeChange('small')}
              >
                <span style={fontSizeIconStyle('small')}>A-</span>
                <span style={fontSizeLabelStyle}>Petit</span>
              </button>
              <button
                style={getFontSizeButtonStyle(settings.fontSize === 'medium')}
                onClick={() => handleFontSizeChange('medium')}
              >
                <span style={fontSizeIconStyle('medium')}>A</span>
                <span style={fontSizeLabelStyle}>Moyen</span>
              </button>
              <button
                style={getFontSizeButtonStyle(settings.fontSize === 'large')}
                onClick={() => handleFontSizeChange('large')}
              >
                <span style={fontSizeIconStyle('large')}>A+</span>
                <span style={fontSizeLabelStyle}>Grand</span>
              </button>
              <button
                style={getFontSizeButtonStyle(settings.fontSize === 'xlarge')}
                onClick={() => handleFontSizeChange('xlarge')}
              >
                <span style={fontSizeIconStyle('xlarge')}>A++</span>
                <span style={fontSizeLabelStyle}>Très Grand</span>
              </button>
            </div>
          </div>

          {/* Version de la Bible */}
          <div style={sectionStyle}>
            <h3 style={sectionTitleStyle}>📖 Version de la Bible</h3>
            <select 
              style={selectStyle}
              value={settings.bibleVersion || 'BDS'}
              onChange={(e) => handleBibleVersionChange(e.target.value)}
            >
              <option value="BDS">Bible du Semeur (BDS)</option>
              <option value="LSG">Louis Segond 1910 (LSG)</option>
              <option value="NEG">Nouvelle Édition de Genève (NEG)</option>
              <option value="TOB">Traduction Œcuménique (TOB)</option>
              <option value="S21">Segond 21 (S21)</option>
              <option value="NFC">Nouvelle Français Courant (NFC)</option>
            </select>
          </div>

          {/* Notifications */}
          <div style={sectionStyle}>
            <h3 style={sectionTitleStyle}>🔔 Notifications</h3>
            <div style={toggleContainerStyle}>
              <span style={toggleLabelStyle}>Activer les notifications de lecture</span>
              <div 
                style={toggleSwitchStyle(settings.notificationsEnabled || false)}
                onClick={handleNotificationsToggle}
              >
                <div style={toggleCircleStyle(settings.notificationsEnabled || false)} />
              </div>
            </div>
          </div>

          {/* Historique & Données */}
          <div style={sectionStyle}>
            <h3 style={sectionTitleStyle}>📜 Historique & Données</h3>
            <div>
              <button style={dangerButtonStyle} onClick={handleClearHistory}>
                🗑️ Effacer tout l'historique
              </button>
              <button style={actionButtonStyle} onClick={handleExportNotes}>
                📥 Exporter mes notes
              </button>
            </div>
          </div>

          {/* Gestion API (Avancé) */}
          <div style={sectionStyle}>
            <button 
              style={advancedToggleStyle}
              onClick={() => setShowAdvanced(!showAdvanced)}
            >
              <span>🔑 Gestion API (Avancé)</span>
              <span>{showAdvanced ? '▲' : '▼'}</span>
            </button>
            
            {showAdvanced && (
              <div style={{marginTop: '15px'}}>
                {apiStatus ? (
                  <>
                    <div style={{marginBottom: '15px'}}>
                      <div style={{fontSize: '14px', color: '#64748b', marginBottom: '10px'}}>
                        Statut des API :
                      </div>
                      <div style={apiGridStyle}>
                        {Object.entries(apiStatus).map(([key, value]) => (
                          <div key={key} style={apiLedStyle(value === 'operational' || value?.color === 'green')}>
                            {key === 'mistral' ? 'Mistral' : key === 'bible_api' ? 'Bible' : key}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div style={{fontSize: '13px', color: '#64748b', fontStyle: 'italic'}}>
                      🟢 Vert = Opérationnel | 🔴 Rouge = Indisponible
                    </div>
                  </>
                ) : (
                  <div style={{padding: '15px', textAlign: 'center', color: '#64748b'}}>
                    Chargement du statut API...
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Aperçu */}
          <div style={sectionStyle}>
            <h3 style={sectionTitleStyle}>👁️ Aperçu</h3>
            <div style={previewBoxStyle}>
              <p style={previewTextStyle}>
                Au commencement, Dieu créa les cieux et la terre.
              </p>
              <p style={previewCaptionStyle}>Genèse 1:1 - {settings.bibleVersion || 'BDS'}</p>
            </div>
          </div>

          <button style={saveBtnStyle} onClick={onClose}>
            ✓ Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsPanel;
